/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

jQuery(document).ready(function($) {
  $(document).on('click', '.js-store-picker-popup__trigger', function () {
    $('.store-picker-popup').addClass('store-picker-popup--active');
  });
  
  $(document).on('click', '.js-store-picker-popup__close', function () {
    $('.store-picker-popup').removeClass('store-picker-popup--active');
  });
  
  $(document).on('click', '.js-store-picker-popup__overlay', function () {
    $('.store-picker-popup').removeClass('store-picker-popup--active');
  });
  
  $(document).on('click', '.js-spl__item', function() {
    window.location.href = $(this).data('href');
  });
  
  function initializeTestimonials() {
    if ($('.wide-testimonial__items').length > 0 && !$('.wide-testimonial__items').hasClass('flickity-enabled')) {
      $('.wide-testimonial__items').flickity();
    }
  }
  
  function destroyTestimonials() {
    if ($('.wide-testimonial__items').length > 0 && $('.wide-testimonial__items').hasClass('flickity-enabled')) {
      $('.wide-testimonial__items').flickity('destroy');
    }
  }
  
  $(window).on('resize', function(){
    var win = $(this);
    if (win.width() > 768) {
      destroyTestimonials();
    }
    else {
      initializeTestimonials();
    }
  });
  
  if (window.innerWidth > 768) {
    destroyTestimonials();
  }
  else {
    initializeTestimonials();
  }
  
  $(document).on('click', '.js-ProductForm__AddToCart', function() {
    var params = [];
    var item1 = $(this).attr('data-product1');
    var item2 = $(this).attr('data-product2');
    var bundle = '3';
    if (item1 == '33147611316301') {
      bundle = '2';
    }
    if (item1 == '33220614946893' || item1 == '33220614324301') {
      bundle = '4';
    }
    if (item1 == '33147611316301' && item2 == '32947197935693') {
      bundle = '3';
      params.push({
        quantity: 1,
        id: item1,
        properties: {
          bundle: bundle
        }
      });
      bundle = '2';
      params.push({
        quantity: 1,
        id: item2,
        properties: {
          bundle: bundle
        }
      });
    }
    else {
      if (item1) {
        params.push({
          quantity: 1,
          id: item1,
          properties: {
            bundle: bundle
          }
        });
      }

      if (item2) {
        if (item1 != item2) {
          params.push({
            quantity: 1,
            id: item2,
            properties: {
              bundle: bundle
            }
          });
        }
        else {
          params[0].quantity = 2;
        }
      }
    }
    
    var item3 = $(this).attr('data-product3');
    if (item3) {
      if (item3 == item1 && item3 == item2) {
        params[0].quantity = 3;
      }
      else if (item3 != item1 && item3 == item2) {
        params[1].quantity = 2;
      }
      else {
        params.push({
          quantity: 1,
          id: item3,
          properties: {
            bundle: bundle
          }
        });
      }
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js', 
      dataType: 'json',
      data: {
        items: params
      },
      success: function(data) {
        /*
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: params[0].id,
            quantity: params[0].quantity
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: params[1].id,
            quantity: params[1].quantity
          }
        }));
        */
        window.location.href = '/cart';
      }
    });
  });
});